import type {
  AlertAssignee,
  AlertListQuery,
  AlertReassignInput,
  AlertResolveInput,
  AlertRuleInput,
  AlertRuleListQuery,
  AlertRuleView,
  AlertTransitionInput,
  AlertView,
  Page,
} from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export type { AlertRuleView, AlertView };

export function listAlerts(query: AlertListQuery): Promise<Page<AlertView>> {
  return api<Page<AlertView>>(`/alerts?${toListParams(query)}`);
}

export function acknowledgeAlert(id: string, input: AlertTransitionInput = {}): Promise<AlertView> {
  return api<AlertView>(`/alerts/${id}/acknowledge`, { method: 'POST', body: JSON.stringify(input) });
}

export function resolveAlert(id: string, input: AlertResolveInput): Promise<AlertView> {
  return api<AlertView>(`/alerts/${id}/resolve`, { method: 'POST', body: JSON.stringify(input) });
}

export function reassignAlert(id: string, input: AlertReassignInput): Promise<AlertView> {
  return api<AlertView>(`/alerts/${id}/reassign`, { method: 'POST', body: JSON.stringify(input) });
}

/** People who can answer alerts, matching `q` in name or email. */
export function listAlertAssignees(q?: string): Promise<AlertAssignee[]> {
  return api<AlertAssignee[]>(`/alerts/assignees${q ? `?${new URLSearchParams({ q })}` : ''}`);
}

/** The server-sent events stream of alert changes; a plain path, because `EventSource` does the request itself. */
export const ALERT_STREAM_URL = '/api/v1/alerts/stream';

export function listAlertRules(query: AlertRuleListQuery): Promise<Page<AlertRuleView>> {
  return api<Page<AlertRuleView>>(`/alert-rules?${toListParams(query)}`);
}

export function createAlertRule(input: AlertRuleInput): Promise<AlertRuleView> {
  return api<AlertRuleView>('/alert-rules', { method: 'POST', body: JSON.stringify(input) });
}

export function updateAlertRule(id: string, input: AlertRuleInput): Promise<AlertRuleView> {
  return api<AlertRuleView>(`/alert-rules/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export function setAlertRuleEnabled(id: string, isEnabled: boolean): Promise<AlertRuleView> {
  return api<AlertRuleView>(`/alert-rules/${id}/${isEnabled ? 'enable' : 'disable'}`, { method: 'POST' });
}
